import blocks from './blocks';
import components from './components';

export default (editor, config) => {
  components(editor, config);
  blocks(editor, config);
};
